import { useSelector } from "react-redux";
import useFormFieldConfigByProfile from "hooks/use-form-field-config-by-profile";
import { getFieldLabels } from "app/main/referrals/utils/referral-fieldLabels";
import { getSignedInOrgUnit } from "app/auth/store/reducers/user.reducer";

// Load form field settings - 'CreateEditReferral';
// If formFieldConfigurationId is provided:
//  -- Load that specific form field configuration
// When no specific formFieldConfigurationId is provided:
//  -- Load the form field configuration linked to the default form profile
const useReferralFieldSettings = formFieldConfigurationId => {
  const signedInOrgUnitId = useSelector(state => getSignedInOrgUnit(state))?.id;

  // returned fieldSettings will be the form field configuration linked to the default form profile if formFieldConfigurationId is not provided
  // otherwise the specific form field configuration
  const { fieldSettings } = useFormFieldConfigByProfile(signedInOrgUnitId, formFieldConfigurationId);

  return {
    fieldSettings,
    fieldLabels: getFieldLabels(fieldSettings),
  };
};

export default useReferralFieldSettings;
